import { ChallengeEditor } from '@/components/challenges/editor/ChallengeEditor';
import { useParams } from 'react-router-dom';

/**
 * Library challenge create/edit page — a thin wrapper around the unified
 * `<ChallengeEditor>`. Mounted at `/challenges/new` and
 * `/challenges/:id/edit`.
 */
export function ChallengeFormPage() {
  const { id } = useParams<{ id: string }>();
  const challengeId = id === 'new' ? undefined : id;

  return <ChallengeEditor context="library" challengeId={challengeId} />;
}
